export default {
  logs(state, value) {
    return (state.logs = value);
  },
  totalLogs(state, value) {
    return (state.totalLogs = value);
  },
  tableLoading(state, value) {
    return (state.tableLoading = value);
  },
  perPageForLogs(state, value) {
    return (state.perPageForLogs = value);
  },
  currentPageForLogs(state, value) {
    return (state.currentPageForLogs = value);
  },
  searchQuery(state, value) {
    return (state.searchQuery = value);
  },
  filterDate(state, value) {
    return (state.filterDate = value);
  },
  filterStatus(state, value) {
    return (state.filterStatus = value);
  },
};
